import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5062/api';

export default function HastaLogin() {
  const [cepTel,     setCepTel]     = useState('');
  const [kimlikNo,   setKimlikNo]   = useState('');
  const [hata,       setHata]       = useState('');
  const [yukleniyor, setYukleniyor] = useState(false);
  const navigate = useNavigate();

  const handleCepTel = (e) => {
    const val = e.target.value.replace(/\D/g, '').slice(0, 11);
    setCepTel(val);
  };

  const handleGiris = async (e) => {
    e.preventDefault();
    if (!cepTel || cepTel.length < 11) { setHata('Lütfen 11 haneli cep telefon numaranızı giriniz.'); return; }
    if (!kimlikNo) { setHata('Lütfen Kimlik No giriniz.'); return; }
    setHata('');
    setYukleniyor(true);
    try {
      const res = await axios.post(`${apiUrl}/Auth/hasta-giris`, { cepTel, kimlikNo });
      const data = res.data;
      localStorage.setItem('kullanici', JSON.stringify({
        kayitNo:   data.kayitNo,
        adSoyad:   data.adSoyad,
        dokKod:    0,
        girisTipi: 1,
      }));
      localStorage.setItem('giristipi', 'hasta');
      localStorage.setItem('hastaToken', data.hastaToken);
      navigate(`/hasta/${data.kayitNo}`, { replace: true });
    } catch (err) {
      const mesaj = err.response?.data?.mesaj || 'Cep Telefon No veya Kimlik No hatalı.';
      setHata(mesaj);
    } finally {
      setYukleniyor(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(160deg, #e8f4f8 0%, #f0eaff 50%, #eafaf1 100%)',
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
      padding: 24
    }}>
      <div style={{ width: '100%', maxWidth: 380 }}>

        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <img src="/images/kurum_logo_200.png" alt="Logo" style={{ maxWidth: '100%', objectFit: 'contain' }} />
        </div>

        {/* Kart */}
        <div style={{
          background: '#fff', borderRadius: 18,
          boxShadow: '0 8px 32px rgba(100,80,200,.12)',
          overflow: 'hidden'
        }}>
          {/* Başlık */}
          <div style={{ background: 'linear-gradient(135deg, #7C5CBF, #1D9E75)', padding: '18px 24px' }}>
            <div style={{ color: '#fff', fontSize: 17, fontWeight: 700 }}>🏥 Hasta Girişi</div>
            <div style={{ color: 'rgba(255,255,255,0.7)', fontSize: 12, marginTop: 3 }}>Tıbbi dosyanıza erişmek için giriş yapın</div>
          </div>

          {/* Form */}
          <form onSubmit={handleGiris} style={{ padding: '22px 24px' }}>

            <div style={{ marginBottom: 16 }}>
              <label style={{ fontSize: 11, fontWeight: 700, color: '#7C5CBF', display: 'block', marginBottom: 6, textTransform: 'uppercase', letterSpacing: '.5px' }}>
                Cep Telefon No
              </label>
              <input
                type="tel"
                value={cepTel}
                onChange={handleCepTel}
                placeholder="05xxxxxxxxx"
                maxLength={11}
                inputMode="numeric"
                style={{
                  border: `1.5px solid ${cepTel.length > 0 && cepTel.length < 11 ? '#e57373' : '#c5b3f0'}`,
                  borderRadius: 8, background: '#faf8ff', color: '#3d2f6e', fontWeight: 500
                }}
              />
              {cepTel.length > 0 && cepTel.length < 11 && (
                <div style={{ fontSize: 11, color: '#e57373', marginTop: 4 }}>{cepTel.length}/11 hane</div>
              )}
            </div>

            <div style={{ marginBottom: 22 }}>
              <label style={{ fontSize: 11, fontWeight: 700, color: '#7C5CBF', display: 'block', marginBottom: 6, textTransform: 'uppercase', letterSpacing: '.5px' }}>
                Kimlik No
              </label>
              <div style={{ fontSize: 11, color: '#999', marginBottom: 6 }}>( TC Kimlik, Yabancı Kimlik, Pasaport )</div>
              <input
                type="password"
                value={kimlikNo}
                onChange={e => setKimlikNo(e.target.value)}
                placeholder="••••••••••••"
                style={{ border: '1.5px solid #c5b3f0', borderRadius: 8, background: '#faf8ff', color: '#3d2f6e' }}
              />
            </div>

            {hata && (
              <div style={{ background: '#FCEBEB', color: '#A32D2D', padding: '10px 14px', borderRadius: 8, fontSize: 13, marginBottom: 16 }}>
                {hata}
              </div>
            )}

            <button
              type="submit"
              disabled={yukleniyor}
              style={{
                width: '100%', padding: '13px',
                background: 'linear-gradient(135deg, #7C5CBF, #a07de0)',
                color: '#fff', border: 'none', borderRadius: 10,
                fontSize: 15, fontWeight: 700, cursor: 'pointer',
                boxShadow: '0 4px 12px rgba(124,92,191,.35)'
              }}
            >
              {yukleniyor ? 'Giriş yapılıyor...' : '🔐 GİRİŞ YAP'}
            </button>

          </form>
        </div>
      </div>
    </div>
  );
}
